// src/components/CreatePassword.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import passwordImage from "../assets/images/password.png";
import API_ENDPOINTS from "../config/api";

const CreatePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, account } = location.state || {};

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [obscurePassword, setObscurePassword] = useState(true);
  const [obscureConfirmPassword, setObscureConfirmPassword] = useState(true);

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-=[\]{};:,.<>?])[A-Za-z\d!@#$%^&*_\-=[\]{};:,.<>?]{8,}$/;
    return passwordRegex.test(password);
  };

  const createPassword = async () => {
    if (!password || !confirmPassword) {
      toast.warn("Password fields cannot be empty");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (!validatePassword(password)) {
      toast.warn(
        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return;
    }

    try {
      const response = await axios.post(
        API_ENDPOINTS.CREATE_PASSWORD,
        {
          email,
          account,
          password,
        }
      );

      if (response.status === 200) {
        toast.success("Password created successfully");
        navigate("/signin");
      } else {
        toast.error("Failed to create password");
      }
    } catch (error) {
      console.error("Error creating password:", error);
      if (error.response?.status === 403) {
        toast.error(error.response.data.error);
        setTimeout(() => navigate("/signin"), 3000);
      } else {
        toast.error("Failed to create password");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-white">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <h1 className="text-3xl font-bold mb-6 text-center">Create Password</h1>

      <div className="w-full max-w-md lg:max-w-lg bg-white rounded-lg shadow-md p-6 text-center">
        <img
          src={passwordImage}
          alt="Create Password"
          className="mx-auto mb-6 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5"
        />

        <div className="mb-4">
          <label className="block mb-2 text-sm lg:text-base">Password</label>
          <div className="relative">
            <input
              type={obscurePassword ? "password" : "text"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border rounded-md text-sm lg:text-base"
            />
            <button
              type="button"
              onClick={() => setObscurePassword(!obscurePassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-700 text-sm"
            >
              {obscurePassword ? "Show" : "Hide"}
            </button>
          </div>
        </div>

        <div className="mb-6">
          <label className="block mb-2 text-sm lg:text-base">
            Confirm Password
          </label>
          <div className="relative">
            <input
              type={obscureConfirmPassword ? "password" : "text"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full p-3 border rounded-md text-sm lg:text-base"
            />
            <button
              type="button"
              onClick={() => setObscureConfirmPassword(!obscureConfirmPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-700 text-sm"
            >
              {obscureConfirmPassword ? "Show" : "Hide"}
            </button>
          </div>
        </div>

        <button
          onClick={createPassword}
          className="w-full py-3 bg-teal-600 text-white rounded-md text-lg font-semibold hover:bg-teal-700 transition"
        >
          Create Password
        </button>
      </div>
    </div>
  );
};

export default CreatePassword;
